import { render, staticRenderFns } from "./DesgloseVentas.vue?vue&type=template&id=2ec65ec5"
import script from "./DesgloseVentas.vue?vue&type=script&lang=js"
export * from "./DesgloseVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports